import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Reveal } from "@/components/Reveal";

const BE = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u?.startsWith("http") ? u : `${BE}${u}`);

export const GallerySection = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/gallery").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <section id="realisations" className="bg-white border-y border-line">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <Reveal className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.4em] text-olive font-semibold">Réalisations</span>
          <h2 className="mt-5 font-display text-4xl md:text-5xl text-forest tracking-tight">Avant / après</h2>
          <p className="mt-4 text-ink-soft">Glissez le curseur pour découvrir la transformation de nos chantiers.</p>
        </Reveal>
        <div className="mt-14 grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-testid="gallery-grid">
          {items.map((it) => (
            <Reveal key={it.id} className="space-y-4">
              <BeforeAfter before={abs(it.before_url)} after={abs(it.after_url)} label={it.category} />
              <div>
                <h3 className="font-display text-2xl text-forest">{it.title}</h3>
                {it.description && <p className="mt-1 text-sm text-ink-soft">{it.description}</p>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
